import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LogoutPromptService {
  showLogoutPrompt$(): Observable<boolean> {
    return of(confirm('If your login is also used for other applications, you may be logged out of those as well.'));
  }
}
